/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetAlliancesAllianceIdIconsOk
 */
export interface GetAlliancesAllianceIdIconsOk {
    /**
     * px128x128 string
     * @type {string}
     * @memberof GetAlliancesAllianceIdIconsOk
     */
    px128x128?: string;
    /**
     * px64x64 string
     * @type {string}
     * @memberof GetAlliancesAllianceIdIconsOk
     */
    px64x64?: string;
}

/**
 * Check if a given object implements the GetAlliancesAllianceIdIconsOk interface.
 */
export function instanceOfGetAlliancesAllianceIdIconsOk(value: object): value is GetAlliancesAllianceIdIconsOk {
    return true;
}

export function GetAlliancesAllianceIdIconsOkFromJSON(json: any): GetAlliancesAllianceIdIconsOk {
    return GetAlliancesAllianceIdIconsOkFromJSONTyped(json, false);
}

export function GetAlliancesAllianceIdIconsOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAlliancesAllianceIdIconsOk {
    if (json == null) {
        return json;
    }
    return {
        
        'px128x128': json['px128x128'] == null ? undefined : json['px128x128'],
        'px64x64': json['px64x64'] == null ? undefined : json['px64x64'],
    };
}

export function GetAlliancesAllianceIdIconsOkToJSON(json: any): GetAlliancesAllianceIdIconsOk {
    return GetAlliancesAllianceIdIconsOkToJSONTyped(json, false);
}

export function GetAlliancesAllianceIdIconsOkToJSONTyped(value?: GetAlliancesAllianceIdIconsOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'px128x128': value['px128x128'],
        'px64x64': value['px64x64'],
    };
}

